export const tableLoaders = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]

/*
{
      "id":"cb306e5b-59ad-4169-a3e5-917a553a852f",
      "dataCriacao":"2024-12-06T16:20:22.5433",
      "storageId":"786c8ea4-611e-4ad9-b903-e47a6f141723",
      "tipoDocumento":2,
      "nomeArquivo":"teste2.pdf",
      "instituicaoId":1
   },
*/

export const defaultTableHeaders = [
    {
        name: 'nomeArquivo',
        text: 'Nome Arquivo',
        position: 0
    },
    {
        name: 'tipoDocumento',
        text: 'Tipo Documento',
        position: 1
    },
    {
        name: 'dataCriacao',
        text: 'Data Criação',
        position: 2
    }
]
